import { SVGProps } from 'react';

const ThumbScaleSmallKindUpReducedTrue = (props: SVGProps<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M6.00004 12.6667V7.00001M3.33337 8.46668V11.7333C3.33337 12.2488 3.76187 12.6667 4.29045 12.6667H10.7154C11.424 12.6667 12.0266 12.1625 12.1344 11.4796L12.6497 8.21289C12.7835 7.36483 12.1107 6.60001 11.2308 6.60001H9.55438C9.29009 6.60001 9.07584 6.39108 9.07584 6.13334V4.48407C9.07584 3.84854 8.54754 3.33334 7.89584 3.33334C7.7404 3.33334 7.59954 3.42261 7.53641 3.56113L5.85237 7.25621C5.77557 7.42473 5.60419 7.53334 5.41508 7.53334H4.29045C3.76187 7.53334 3.33337 7.95121 3.33337 8.46668Z"
            stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            strokeWidth={1.33333}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export default ThumbScaleSmallKindUpReducedTrue;
